import { SPI, DialogViewActionWidget, BaseActionWidget, ClickResult, Widget, REFRESH_FORM_DATA, WidgetSubjection, type ObjectValue, ServerActionWidget, debugConsole } from '@kunlun/dependencies';

@SPI.ClassFactory(
    BaseActionWidget.Token({
        model: 'deli.retail.BackendRetailCategoryProxy',
        name: 'delete',
        widget: 'ServerAction'
    })
)
export class RetailCateDelAction extends ServerActionWidget {
    initialize(props: any) {
        super.initialize(props);
        return this;
    }
    protected async clickAction(): Promise<ClickResult> {
        const { action } = this;
        if (!action) {
            console.error('无法处理没有运行时动作的点击动作');
            return;
        }

        debugConsole.group(`Click serverAction. ${action.model}:${action.name}`);
        const submitValue = await this.submit(action);
        const { records } = submitValue
        if (Array.isArray(records)) {
            submitValue.records = records[0]
        }
        try {
            return await this.executeAction(action, submitValue);
        } catch (e) {
            console.error(e);
            const { forceRefreshWhenError = false } = this.getDsl();
            if (forceRefreshWhenError) {
                this.refreshCallChaining?.syncCall();
            }

            return false;
        } finally {
            debugConsole.groupEnd();
        }
    }
}
